import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'hpf-category',
  templateUrl: './category.component.html'
})
export class CategoryComponent implements OnInit {

  /** Constructor */
  constructor() {}

  /** Init */
  ngOnInit() {}

}
